import React from 'react';

export const Label = ({ children, required = false, htmlFor }) => {
  return (
    <label className={`field__label ${required ? 'field__label--required' : ''}`} htmlFor={htmlFor}>
      {children}
    </label>
  );
};
